@if (navigationBreadcrumb) {
<qa-navigation-breadcrumbs
  [navigationBreadcrumb]="navigationBreadcrumb"
></qa-navigation-breadcrumbs>
}
<div class="row">
  @if (config) {
  <qa-grid-data [config]="config"></qa-grid-data>
  }
</div>
